module.exports = __webpack_public_path__ + "img/05_overlay.1e0e4292.png";